import React, { useMemo } from 'react';

import { IconAlertTriangleFilled, IconCircleFilled, IconX } from '@tabler/icons-react';

import Button from '@lotlinx-aws/sparky-component-library/Sparky/Button';
import Flex from '@lotlinx-aws/sparky-component-library/Sparky/Flex';
import IconButton from '@lotlinx-aws/sparky-component-library/Sparky/IconButton';
import Modal from '@lotlinx-aws/sparky-component-library/Sparky/Modal';
import Text from '@lotlinx-aws/sparky-component-library/Sparky/Text';

import styles from './SelectorModal.module.scss';

interface SelectorModalProps {
  isOpen: boolean;
  onCancel: () => void;
  onContinue: () => void;
  dealers: any[];
  dealerList: any[];
}

const SelectorModal: React.FC<SelectorModalProps> = ({
  isOpen,
  onCancel,
  onContinue,
  dealers,
  dealerList,
}) => {
  const dealerNameMap = useMemo(() => {
    const map = new Map();
    dealerList.forEach((dealer) => map.set(dealer.dealerId, dealer.dealerName));
    return map;
  }, [dealerList]);

  return (
    <Modal
      isOpen={isOpen}
      onDismiss={onCancel}
      contentClassName={styles.deselectionModal}
      aria-label='Local Market Settings'
    >
      <div className={styles.modalContainer}>
        <div className={styles.modalHeader}>
          <IconButton aria-label='modal-dismissal' onClick={onCancel}>
            <IconX color='#888888' />
          </IconButton>
        </div>
        <div className={styles.modalBody}>
          <Flex>
            <IconAlertTriangleFilled color='#FF0000' />
          </Flex>
          <Text type='label-emphasized-01' color='red' alignment='center'>
            You've deselected cells that contains key competitors
          </Text>
          <Text type='body-01' color='secondary' alignment='center'>
            The following dealers will be removed as key competitors:
          </Text>
          <Flex column width='100%' alignItems='center'>
            {dealers.map((i) => (
              <Flex alignItems='center' gap='8px' key={i.dealerId}>
                <IconCircleFilled size={6} color='#4B4B4B' />
                <Text type='body-01' color='secondary' alignment='center'>
                  {dealerNameMap.get(i.dealerId)}
                </Text>
              </Flex>
            ))}
          </Flex>
          <div className={styles.buttonRow}>
            <Button
              category='danger'
              variant='outline'
              onClick={onCancel}
              className={styles.cancelButton}
            >
              Cancel
            </Button>
            <Button category='danger' variant='solid' onClick={onContinue}>
              Continue
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default SelectorModal;
